import { Injectable } from '@angular/core';
import { translate } from '@jsverse/transloco';
import moment from 'moment';
import { Constants } from 'src/app/models/constants';

@Injectable({
  providedIn: 'root'
})
export class DateTimeService {

  constructor() {
  }

  /**
   * Calculates the difference between two dates in a specified time unit
   *
   * @param firstDate - the first date
   * @param secondDate - the second one
   * @param timeUnit - the time unit indicating how to calculate the difference
   * @returns the difference between those two days in a specified time unit
   */
   differenceBetweenDates(firstDate: any, secondDate: any, timeUnit: any): number {
    switch(timeUnit) {
      case Constants.TIME_UNIT_DAY: return Math.round(moment.duration(moment(secondDate).diff(firstDate)).asDays());
      case Constants.TIME_UNIT_HOUR: return Math.round(moment.duration(moment(secondDate).diff(firstDate)).asHours());
      case Constants.TIME_UNIT_SECOND: return Math.round(moment.duration(moment(secondDate).diff(firstDate)).asSeconds());
    }
  }

  /**
   * Calculates the result dates after subtracting the difference
   *
   * @param difference - the difference to be applied for subtraction
   * @param timeUnit - an indication whether the difference should be calculated for days, hours etc
   * @param dateTimeFormat - the format of the result date
   * @returns the result dates after subtracting the difference
   */
  subtractFromCurrentDate(difference: number, timeUnit: any, dateTimeFormat: string): any {
    return {
      firstDate: moment().subtract(difference, timeUnit).format(dateTimeFormat),
      secondDate: moment().format(dateTimeFormat)
    };
  }

  /**
   * Creates a string representation of dates interval
   *
   * @param firstDate - the first date
   * @param secondDate - the second one
   * @param dateTimeFormat - the format to use for dates
   * @returns string representation of dates interval
   */
  getDateIntervalAsString(firstDate: string, secondDate: string, dateTimeFormat: string): string {
    const first = firstDate ? this.format(firstDate, dateTimeFormat) : translate('AUDIT_TRAIL.FILTER.UNSPECIFIED');
    const second = secondDate ? this.format(secondDate, dateTimeFormat) : translate('AUDIT_TRAIL.FILTER.UNSPECIFIED');
    return first + ' - ' + second;
  }

  /**
   * Checks if the first date is after the second date
   *
   * @param firstDate - the first date
   * @param secondDate - the second one=
   * @returns true if the first date is after the second one, false otherwise
   */
  isAfter(firstDate: string, secondDate: string): boolean {
    return moment(firstDate).isAfter(moment(secondDate));
  }

  /**
   * Formats the date in the desired date time format
   *
   * @param date - the date to be formatted
   * @param dateTimeFormat - the format of the result date
   * @returns the formatted date
   */
  format(date: string, dateTimeFormat: string): string {
    return moment(date).format(dateTimeFormat);
  }
}
